
















import Vue from 'vue';

export default Vue.extend({
  name: 'PreferencesInputBlock',
  props: {
    title: String,
    icons: Array,
    bottomLine: Boolean,
  },
  computed: {},
});
